<template lang="pug">
  div.analytic.charts
    Toolbar
    div.dashboard
      div.col
        chart-dynamic
        chart-garbage
        chart-msn

      div.col
        chart-garbage-volume
        chart-garbage-handling-dynamic
        chart-garbage-output

      div.col
        chart-garbage-production(:limit="10")
        chart-msn-container


</template>
<script>
  import Toolbar from './components/toolbar.vue'
  import chartsMixin from './mixins/charts-mixin.js'

  import ChartDynamic from './components/chart-dynamic'
  import ChartGarbage from './components/chart-garbage'
  import ChartGarbageHandlingDynamic from './components/chart-garbage-handling-dynamic'
  import ChartGarbageProduction from './components/chart-garbage-production'
  import ChartGarbageVolume from './components/chart-garbage-volume'
  import ChartMsn from './components/chart-msn'
  import ChartMsnContainer from './components/chart-msn-container'
  import ChartGarbageOutput from './components/chart-garbage-output'

  export default {
    mixins: [chartsMixin],
    title: null,
    components: {
      ChartMsnContainer,
      ChartMsn,
      ChartGarbageVolume,
      ChartGarbageProduction,
      ChartGarbageHandlingDynamic,
      ChartGarbage,
      ChartDynamic,
      ChartGarbageOutput,
      Toolbar
    }
  }
</script>
